export const PROPERTIES_MAIN_OVERLAY_ID = "overlay-property";
